import React, { useEffect, useMemo, useState } from "react";
import axios from "axios";

import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import TextField from "@mui/material/TextField";
import { useAlerta } from "utils/alertas";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";
import Switch from "@mui/material/Switch";
import FormControlLabel from "@mui/material/FormControlLabel";

import DataTable from "examples/Tables/DataTable";

const AcademicoNotas = () => {

  const [grupos, setGrupos] = useState([]);
  const [materias, setMaterias] = useState([]);
  const [evaluaciones, setEvaluaciones] = useState([]);
  const [gestiones, setGestiones] = useState([]);
  const [gestion, setGestion] = useState("");
  const [semestres, setSemestres] = useState([]);
  const [semestre, setSemestre] = useState("");

  const [carreras, setCarreras] = useState([]);
  const [carrera, setCarrera] = useState("");
  const [tipoEntidad, setTipoEntidad] = useState(""); // "carrera" o "capacitacion"
  const [entidadId, setEntidadId] = useState("");     // id seleccionado

  const [capacitaciones, setCapacitaciones] = useState([]);

  const [grupo, setGrupo] = useState("");
  const [materia, setMateria] = useState("");
  const [evaluacion, setEvaluacion] = useState("");
    const { mostrarAlerta } = useAlerta();
  const [estadoEvaluacion, setEstadoEvaluacion] = useState({
    abierta: false
  });
  const [estudiantes, setEstudiantes] = useState([]);

  const token = sessionStorage.getItem("access_token");
  useEffect(() => {
    const cargarDatosIniciales = async () => {
      try {
        await Promise.all([
          cargarEvaluaciones(),
          cargarCarreras(),
          cargarCapacitaciones(),
          cargarGestiones()
        ]);
      } catch (error) {
        console.error("Error cargando datos iniciales:", error);
      }
    };

    cargarDatosIniciales();
  }, []);
  const cargarCarreras = async () => {
    const res = await axios.get(`${process.env.REACT_APP_API_URL}/carreras`, {
      headers: { Authorization: `Bearer ${token}` }
    });

    setCarreras(res.data);
  };
  useEffect(() => {
  if (tipoEntidad === "capacitacion" && semestres.length > 0) {
    const primero = semestres[0];

    setSemestre(primero.id);

    // importante: dispara carga de materias / grupos
    handleSemestreChange({
      target: { value: primero.id }
    });
  }
}, [tipoEntidad, semestres]);
const cargarGestiones = async () => {
  const res = await axios.get(`${process.env.REACT_APP_API_URL}/gestiones`, {
    headers: { Authorization: `Bearer ${token}` }
  });

  setGestiones(res.data);
};

  const handleDocenteChange = async (e) => {

    const docenteId = e.target.value;

    setDocente(docenteId);
    setMateria("");
    setGrupo("");
    setEstudiantes([]);

    if (!docenteId) return;

    const res = await axios.get(
      `${process.env.REACT_APP_API_URL}/docente/${docenteId}/materias`,
      { headers: { Authorization: `Bearer ${token}` } }
    );

    setMaterias(res.data);

  };
  const handleSemestreChange = async (e) => {
    const semestresId = e.target.value;

    setSemestre(semestresId);

    // Limpiar los datos dependientes
    setMateria("");
    setGrupo("");
    setMaterias([]);
    setGrupos([]);
    setEstudiantes([]);
    setEstadoEvaluacion({ abierta: false });

    if (!semestresId || !gestion) return;

    try {
      const res = await axios.get(
        `${process.env.REACT_APP_API_URL}/grupos/${gestion}/${semestresId}/semestres`,
        {
          headers: {
            Authorization: `Bearer ${token}`
          }
        }
      );

      console.log("GRUPOS DEL SEMESTRE:", res.data);

      setGrupos(res.data.data || []);

    } catch (error) {
      console.error("Error cargando grupos del semestre:", error);
      setGrupos([]);
      mostrarAlerta(
      "Error al cargar los grupos del semestre",
      "error"
      );
    }
  };


  const cargarEvaluaciones = async () => {

    const res = await axios.get(
      `${process.env.REACT_APP_API_URL}/evaluaciones`,
      { headers: { Authorization: `Bearer ${token}` } }
    );

    setEvaluaciones(res.data);
  };
  const handleNotaChange = (index, campo, valor) => {
    // Permitir vacío
    if (valor === "") {
      setEstudiantes((prev) => {
        const nuevos = [...prev];

        nuevos[index] = {
          ...nuevos[index],
          [campo]: ""
        };

        return nuevos;
      });

      return;
    }

    // Solo números
    if (!/^\d+$/.test(valor)) {
      return;
    }

    // Quitar ceros iniciales
    valor = valor.replace(/^0+(?=\d)/, "");

    setEstudiantes((prev) => {
      const nuevos = [...prev];

      nuevos[index] = {
        ...nuevos[index],
        [campo]: valor
      };

      return nuevos;
    });
  };
  const handleNotaBlur = (index, campo) => {
    setEstudiantes((prev) => {
      const nuevos = [...prev];

      const valor = nuevos[index][campo];

      if (valor === "") {
        return nuevos;
      }

      const maximo = campo === "teorico" ? 30 : 70;

      let numero = Number(valor);

      if (numero > maximo) {
        numero = maximo;
      }

      nuevos[index] = {
        ...nuevos[index],
        [campo]: String(numero)
      };

      return nuevos;
    });
  };
  const cargarNotas = async () => {

    const res = await axios.get(
        `${process.env.REACT_APP_API_URL}/grupos/${grupo}/materias/${materia}/estudiantes`,
        {
        headers: { Authorization: `Bearer ${token}` },
        params: {
          evaluacion_id: evaluacion
        }
        }
    );
    const lista = Array.isArray(res.data)
    ? res.data
    : res.data.data || [];

    setEstudiantes(
      lista.map((est) => ({
        ...est,
        nombre: est.nombre ? est.nombre.toUpperCase() : "",
        teorico:
          est.teorico !== null && est.teorico !== undefined
            ? String(Number(est.teorico))
            : "",
        practico:
          est.practico !== null && est.practico !== undefined
            ? String(Number(est.practico))
            : ""
      }))
    );

  };
    useEffect(() => {
      if (!materia || !grupo || !evaluacion) return;
      cargarEstadoEvaluacion();
      cargarNotas();
    }, [materia, grupo, evaluacion]);

  const cargarEstadoEvaluacion = async () => {
    try {
      const res = await axios.get(
        `${process.env.REACT_APP_API_URL}/evaluacion/estado`,
        {
          headers: { Authorization: `Bearer ${token}` },
          params: {
            grupo_id: grupo,
            materia_id: materia,
            evaluacion_id: evaluacion
          }
        }
      );

      setEstadoEvaluacion(res.data);

    } catch (error) {
      console.error("Error estado evaluacion:", error);
    }
  };
  const cambiarEstadoEvaluacion = async (nuevoEstado) => {
    try {

      await axios.post("/evaluacion/estado", {
        grupo_id: grupo,
        materia_id: materia,
        evaluacion_id: evaluacion,
        abierta: nuevoEstado
      });

      setEstadoEvaluacion({ abierta: nuevoEstado });

    } catch (error) {
      console.error("Error cambiando estado", error);
    }
  };
  const handleGrupoChange = async (e) => {
    const grupoId = e.target.value;

    setGrupo(grupoId);
    setMateria("");
    setMaterias([]);
    setEstudiantes([]);
    setEvaluacion("");
    setEstadoEvaluacion({ abierta: false });

    if (!grupoId) return;

    try {
      const res = await axios.get(
        `${process.env.REACT_APP_API_URL}/grupos/${grupoId}/materias`,
        {
          headers: {
            Authorization: `Bearer ${token}`
          }
        }
      );
      console.log("MATERIAS ASIGNADAS AL GRUPO:", res.data);

      setMaterias(res.data.data || []);

    } catch (error) {
      console.error("Error cargando materias del grupo:", error);
      setMaterias([]);
      mostrarAlerta(
        "Error al cargar las materias del grupo",
        "error"
      );

    }
  };

  const handleMateriaChange = (e) => {
    setMateria(e.target.value);
    setEstudiantes([]);
    setEvaluacion("");
    setEstadoEvaluacion({ abierta: false });
  };
  
  const cargarCapacitaciones = async () => {
    const res = await axios.get(`${process.env.REACT_APP_API_URL}/modulos`, {
      headers: { Authorization: `Bearer ${token}` }
    });

    setCapacitaciones(res.data.data);
  };
  const filtroSemestres = async (tipo, programa_id) => {
    try {
      const res = await axios.get(
        `${process.env.REACT_APP_API_URL}/semestre/${tipo}/${programa_id}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            Accept: "application/json"
          }
        }
      );
      const lista = Array.isArray(res.data.data)
        ? res.data.data
        : res.data;
      setSemestres(lista || []);
    } catch (error) {
      console.error("Error cargando semestres:", error);
      setSemestres([]);
    }
  };
  const handleEntidadChange = async (e) => {
    const id = e.target.value;

    setEntidadId(id);

    // limpiar dependientes
    setSemestre("");
    setGrupo("");
    setMateria("");
    setEstudiantes([]);

    if (!id || !tipoEntidad) return;

    filtroSemestres(tipoEntidad, id); 
  };


  const resumen = estudiantes.reduce(
    (acc, est) => {
      const teorico = Number(est.teorico) || 0;
      const practico = Number(est.practico) || 0;
      const total = teorico + practico;

      acc.total++;

      if (total >= 61) {
        acc.aprobados++;
      } else {
        acc.reprobados++;
      }

      return acc;
    },
    {
      total: 0,
      aprobados: 0,
      reprobados: 0
    }
  );

  const totalEstudiantes = resumen.total;
  const aprobados = resumen.aprobados;
  const reprobados = resumen.reprobados;

  const hayNotasRegistradas = estudiantes.some(
    e => e.nota_existe !== null && e.nota_existe !== undefined
  );

  const columns = [
    { Header: "Nombre Completo", accessor: "nombre" },
    { Header: "Teórico (30)", accessor: "teorico" },
    { Header: "Práctico (70)", accessor: "practico" },
    { Header: "Total", accessor: "total" },
    { Header: "Estado", accessor: "estado" }
  ];

  const rows = useMemo(() => {
    return estudiantes.map((est, index) => {
      const total =
        (Number(est.teorico) || 0) +
        (Number(est.practico) || 0);

      const estado = total >= 61 ? "APROBADO" : "REPROBADO";

      return {
        nombre: est.nombre,

        teorico: (
          <TextField
            type="text"
            size="small"
            value={est.teorico ?? ""}
            onChange={(e) =>
              handleNotaChange(index, "teorico", e.target.value)
            }
            onBlur={() => handleNotaBlur(index, "teorico")}
            inputProps={{
              inputMode: "numeric",
              pattern: "[0-9]*"
            }}
          />
        ),

        practico: (
          <TextField
            type="text"
            size="small"
            value={est.practico ?? ""}
            onChange={(e) =>
              handleNotaChange(index, "practico", e.target.value)
            }
            onBlur={() => handleNotaBlur(index, "practico")}
            inputProps={{
              inputMode: "numeric",
              pattern: "[0-9]*"
            }}
          />
        ),

        total: <strong>{total}</strong>,

        estado: (
          <strong style={{ color: total >= 61 ? "green" : "red" }}>
            {estado}
          </strong>
        )
      };
    });
  }, [estudiantes]);

  return (
    <Card>

      {/* TITULO */}

      <MDBox p={3}>
        <MDTypography variant="h5">
          Panel Académico de Notas
        </MDTypography>
      </MDBox>


      {/* FILTROS PRINCIPALES */}

      <MDBox px={3} pb={2}>
        <MDTypography variant="h6" mb={2}>
          Selección Académica
        </MDTypography>
        <Grid container spacing={3}>
          <Grid item xs={12} md={4}>
            <TextField
              select
              label="Tipo"
              fullWidth
              value={tipoEntidad}
              SelectProps={{ native: true }}
              onChange={(e) => {
                const tipo = e.target.value;

                setTipoEntidad(tipo);

                setEntidadId("");
                setSemestre("");
                setSemestres([]);
                setGrupo("");
                setMateria("");
                setEstudiantes([]);
              }}
            >
              <option value=""></option>
              <option value="carrera">Carrera</option>
              <option value="capacitacion">Capacitación</option>
            </TextField>
          </Grid>
          <Grid item xs={12} md={4}>
          <TextField
            select
            label={tipoEntidad === "capacitacion" ? "Capacitación" : "Carrera"}
            fullWidth
            value={entidadId}
            SelectProps={{ native: true }}
            onChange={handleEntidadChange}
            disabled={!tipoEntidad}
          >
            <option value=""></option>

            {tipoEntidad === "carrera" &&
              carreras.map((c) => (
                <option key={c.id} value={c.id}>
                  {c.nombre}
                </option>
              ))}

            {tipoEntidad === "capacitacion" &&
              capacitaciones.map((c) => (
                <option key={c.id} value={c.id}>
                  {c.nombre}
                </option>
              ))}
          </TextField>
        </Grid>
        <Grid item xs={12} md={4}>
          <TextField
            select
            label="Gestión"
            fullWidth
            value={gestion}
            SelectProps={{ native: true }}
            onChange={(e) => {
              setGestion(e.target.value);
              setSemestre("");
              setMateria("");
              setGrupo("");
              setMaterias([]);
              setGrupos([]);
              setEstudiantes([]);
              setEvaluacion("");
              setEstadoEvaluacion({ abierta: false });
            }}
            disabled={!entidadId}
          >
            <option value=""></option>
            {gestiones.map((g) => (
              <option key={g.id} value={g.id}>
                {g.nombre}
              </option>
            ))}
          </TextField>
        </Grid>
        {tipoEntidad !== "capacitacion" && (
          <Grid item xs={12} md={4}>
            <TextField
              select
              label="Semestres/Módulos"
              fullWidth
              value={semestre}
              SelectProps={{ native: true }}
              onChange={handleSemestreChange}
              disabled={!entidadId}
            >
              <option value=""></option>
              {semestres.map((s) => (
                <option key={s.id} value={s.id}>
                  {s.nombre} {s.numero}
                </option>
              ))}
            </TextField>
          </Grid>
        )}
          <Grid item xs={12} md={4}>
            <TextField
              select
              label="Grupo"
              fullWidth
              value={grupo}
              SelectProps={{ native: true }}
              onChange={handleGrupoChange}
              disabled={!semestre || !gestion || !grupos.length}
            >
              <option value=""></option>
              {grupos.map((g) => (
                <option key={g.id} value={g.id}>
                  {g.nombre}
                </option>
              ))}
            </TextField>
          </Grid>
          <Grid item xs={12} md={4}>
            <TextField
              select
              label="Materia"
              fullWidth
              value={materia}
              SelectProps={{ native: true }}
              onChange={handleMateriaChange}
              disabled={!grupo || !materias.length}
            >
              <option value=""></option>

              {materias.map((m) => (
                <option key={m.materia_id} value={m.materia_id}>
                  {m.nombre_materia}
                </option>
              ))}
            </TextField>

            {materia && (
              <MDBox mt={1}>
                <MDTypography variant="button" color="text">
                  Docente:{" "}
                  {materias.find(
                    (m) => String(m.materia_id) === String(materia)
                  )?.nombre_docente || "No asignado"}
                </MDTypography>
              </MDBox>
            )}
          </Grid>
        </Grid>
      </MDBox>


      {/* CONTROL DE EVALUACION */}

      <MDBox px={3} py={2}>
        <MDTypography variant="h6" mb={2}>
          Control de Evaluación
        </MDTypography>

        <Grid container spacing={3} alignItems="center">

          <Grid item xs={12} md={4}>
            <TextField
              select
              label="Evaluación"
              fullWidth
              value={evaluacion}
              SelectProps={{ native: true }}
              onChange={(e) => setEvaluacion(e.target.value)}
              disabled={!grupo}
            >
              <option value=""></option>
              {evaluaciones.map((ev) => (
                <option key={ev.id} value={ev.id}>
                  {ev.nombre}
                </option>
              ))}
            </TextField>
          </Grid>

          <Grid item xs={12} md={4}>
            <FormControlLabel
              control={
                <Switch
                  checked={estadoEvaluacion?.abierta || false}
                  onChange={(e) => cambiarEstadoEvaluacion(e.target.checked)}
                />
              }
              label={
                estadoEvaluacion?.abierta
                  ? "Evaluación abierta"
                  : "Evaluación cerrada"
              }
            />
          </Grid>

        </Grid>
      </MDBox>


      {/* RESUMEN DE ESTUDIANTES */}

      <MDBox px={3} py={2}>
        <MDTypography variant="h6" mb={2}>
          Resumen Académico
        </MDTypography>

        <Grid container spacing={3}>

          <Grid item xs={12} md={3}>
            <MDTypography>Total estudiantes</MDTypography>
            <MDTypography variant="h5">{totalEstudiantes}</MDTypography>
          </Grid>

          <Grid item xs={12} md={3}>
            <MDTypography>Aprobados</MDTypography>
            <MDTypography variant="h5" color="success">
              {aprobados}
            </MDTypography>
          </Grid>

          <Grid item xs={12} md={3}>
            <MDTypography>Reprobados</MDTypography>
            <MDTypography variant="h5" color="error">
              {reprobados}
            </MDTypography>
          </Grid>

        </Grid>
      </MDBox>


      {/* TABLA DE NOTAS */}

      <MDBox p={3}>

        <MDTypography
          variant="h6"
          color={estadoEvaluacion?.abierta ? "success" : "error"}
          mb={2}
        >
          {estadoEvaluacion?.abierta
            ? "Evaluación ABIERTA para carga de notas"
            : "Evaluación CERRADA"}
        </MDTypography>

        <DataTable
          table={{ columns, rows }}
          isSorted={false}
          entriesPerPage={rows.length}
          pagination={false}
          showTotalEntries={false}
        />

      </MDBox>


      {/* ACCIONES */}

      <MDBox p={3} display="flex" justifyContent="flex-end">
          <MDButton
            variant="gradient"
            color={hayNotasRegistradas ? "info" : "success"}
            disabled={!estadoEvaluacion?.abierta} // solo habilitado si evaluación abierta
            onClick={async () => {
              try {
                // preparar payload con las notas
                const payload = {
                  notas: estudiantes.map((est) => ({
                    estudiante_materia_id: est.estudiante_materia_id,
                    grupo_id: grupo,
                    materia_id: materia,
                    evaluacion_id: evaluacion,
                    inscripcion_id: est.inscripcion_id,
                    teorico: est.teorico ?? 0,
                    practico: est.practico ?? 0
                  })),
                  materia_id: materia,
                  evaluacion_id: evaluacion
                }; 
                console.log("Payload a enviar:", payload);

                await axios.post(`${process.env.REACT_APP_API_URL}/notas`, payload, {
                  headers: { Authorization: `Bearer ${token}` }
                });
                
                mostrarAlerta("Notas actualizadas correctamente", "success");
                cargarNotas(); // recargar para actualizar la tabla

              } catch (error) {
                console.error("Error al actualizar notas:", error);
                mostrarAlerta(
                  error.response?.data?.message || "Error al actualizar notas",
                  "error"
                );
              }
            }}
          >
            {hayNotasRegistradas ? "Actualizar Notas" : "Registrar Notas"}
          </MDButton>  
      </MDBox>

    </Card>
  );

};

export default AcademicoNotas;